import { AWSError } from "aws-sdk";

export const isAWSError = (err: any) => {
    return err?.code != null && err?.message != null;
};
export const getFormattedAwsErrorMessage = (err: AWSError, message: string) => {
    let result = message;
    if (err.statusCode != null) {
        result = `${result} ${err.statusCode}`;
    }
    result = `${result} | ${err.code}: ${err.message}`;
    if (err.requestId) {
        result = `${result} (requestID: ${err.requestId})`;
    }
    return result;
};
